<div [formGroup]="form" class="input-grid input-grid-gaps">
  @if (showTitle) {
    <div class="font-bold fr-2 align-self-center">
      {{ translatePrefix + '.title' | translate }}:
    </div>
  }
  <div class="fr-2">
    <app-date-input
      id="{{ 'dateFrom' | generateInputId: idPrefix }}"
      class="fr-2"
      [form]="form"
    ></app-date-input>
  </div>
  @if (showDateTo) {
    <app-date-input
      id="{{ 'dateTo' | generateInputId: idPrefix }}"
      class="fr-2"
      [form]="form"
    ></app-date-input>
  }
  @if (enablePersonSelect) {
    <app-input-existing
      id="{{ 'chosenPersonId' | generateInputId: idPrefix }}"
      [form]="form"
        [ngClass]="{
            'fr-2': !isExistingPersonSelected,
            'fr-6': isExistingPersonSelected && showTitle,
            'fr-8': isExistingPersonSelected && !showTitle,
        }"
      [options]="personOptions"
    ></app-input-existing>
  }
  @if (!isExistingPersonSelected) {
    <app-email-input
      id="{{ 'email' | generateInputId: idPrefix }}"
      [form]="form"
        [ngClass]="{
            'fr-2': showDateTo && showTitle && enablePersonSelect,
            'fr-3': !showDateTo || !showTitle || !enablePersonSelect,
        }"
    ></app-email-input>
  }
  @if (!isExistingPersonSelected) {
    <app-password-input
      id="{{ 'password' | generateInputId: idPrefix }}"
      [form]="form"
      class="fr-2"
    ></app-password-input>
  }
  @if (!isExistingPersonSelected) {
    <div
        [ngClass]="{
        'fr-1': (+showDateTo) + (+showTitle) + (+enablePersonSelect) === 2 && !isExistingPersonSelected,
        'fr-3': (+showDateTo) + (+showTitle) + (+enablePersonSelect) === 1 && !isExistingPersonSelected,
        'fr-5': (+showDateTo) + (+showTitle) + (+enablePersonSelect) === 0 && !isExistingPersonSelected,
    }"></div>
  }

  <!-- new line -->
  @if (!isExistingPersonSelected) {
    <app-text-input
      id="{{ 'titleBeforeName' | generateInputId: idPrefix }}"
      [form]="form"
      label="inputs.titleBeforeName"
    ></app-text-input>
  }
  @if (!isExistingPersonSelected) {
    <app-text-input
      id="{{ 'name' | generateInputId: idPrefix }}"
      [form]="form"
      class="fr-2"
      label="inputs.name"
    ></app-text-input>
  }
  @if (!isExistingPersonSelected) {
    <app-text-input
      id="{{ 'surname' | generateInputId: idPrefix }}"
      [form]="form"
      class="fr-3"
      label="inputs.surname"
    ></app-text-input>
  }
  @if (!isExistingPersonSelected) {
    <app-text-input
      id="{{ 'titleAfterName' | generateInputId: idPrefix }}"
      [form]="form"
      label="inputs.titleAfterName"
    ></app-text-input>
  }
  @if (!isExistingPersonSelected) {
    <app-select-user-group
      class="fr-3"
      [form]="form"
    ></app-select-user-group>
  }
  @if (!isExistingPersonSelected) {
    <app-select-button-sex-input
      id="{{ 'sex' | generateInputId: idPrefix }}"
      [form]="form"
      class="fr-2"
    ></app-select-button-sex-input>
  }

  <!-- new line -->
  @if (!isExistingPersonSelected) {
    <app-text-input
      class="fr-12"
      label="inputs.internNote"
      id="{{ 'note' | generateInputId: idPrefix }}"
      [form]="form"
    ></app-text-input>
  }
</div>

